export interface NinjaRequirement {
  text?: string;
}
